import React, { useEffect, useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../../components/ui/dialog';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { toast } from '../../hooks/use-toast';
import { orgApi } from '../phase567Api';
import { errorMessage } from '../errors';
import PickSelect from '../shared/PickSelect';

export const TEAM_KINDS = [
  { value: 'mortgage', label: 'Mortgage' },
  { value: 'real_estate', label: 'Real Estate' },
  { value: 'hybrid', label: 'Hybrid' },
];

// Ticket 202: edit a team (name, kind, branch, manager) via PATCH
// /v2/org/teams/{id}. Members have their own dialog.
export default function EditTeamDialog({ team, branches, staff, onClose, onSaved }) {
  const [form, setForm] = useState({});
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (!team) return;
    setForm({ name: team.name || '', kind: team.kind || 'mortgage', branch_id: team.branch_id || '', manager_user_id: team.manager_user_id || '' });
  }, [team]);

  const set = (k) => (v) => setForm((f) => ({ ...f, [k]: v }));
  // Changed fields only: re-sending an unchanged manager or branch that has since gone would fail the server check.
  const next = team ? {
    name: String(form.name || '').trim(), kind: form.kind,
    branch_id: form.branch_id || null, manager_user_id: form.manager_user_id || null,
  } : {};
  const body = Object.fromEntries(Object.entries(next).filter(([k, v]) => v !== (team[k] || null)));
  const unchanged = Object.keys(body).length === 0;
  const save = async () => {
    setBusy(true);
    try {
      await orgApi.updateTeam(team.team_id, body);
      toast({ title: 'Team saved' });
      onSaved();
    } catch (e) {
      toast({ title: 'Could not save team', description: errorMessage(e) });
    } finally {
      setBusy(false);
    }
  };

  return (
    <Dialog open={!!team} onOpenChange={(open) => { if (!open) onClose(); }}>
      <DialogContent className="max-w-md">
        <DialogHeader><DialogTitle style={{ color: '#070B5F' }} className="font-serif">Edit team</DialogTitle></DialogHeader>
        <div className="space-y-3">
          <div><Label>Name</Label><Input value={form.name || ''} onChange={(e) => set('name')(e.target.value)} className="mt-1" data-testid="team-name" /></div>
          <PickSelect label="Kind" value={form.kind || 'mortgage'} onChange={set('kind')} options={TEAM_KINDS} testId="team-kind" />
          <PickSelect label="Branch" value={form.branch_id || ''} onChange={set('branch_id')} testId="team-branch"
            options={[{ value: '', label: 'No branch' }, ...branches.map((b) => ({ value: b.branch_id, label: b.name }))]} />
          <PickSelect label="Manager" value={form.manager_user_id || ''} onChange={set('manager_user_id')} testId="team-manager"
            options={[{ value: '', label: 'No manager' }, ...staff.map((m) => ({ value: m.user_id, label: m.name || m.email }))]} />
        </div>
        <div className="flex justify-end gap-2 mt-4">
          <button onClick={onClose} className="btn-outline">Cancel</button>
          <button onClick={save} disabled={busy || unchanged || !String(form.name || '').trim()} className="btn-gold" data-testid="team-save">Save</button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
